import { render, staticRenderFns } from "./ExpensesStastiticNavBar.vue?vue&type=template&id=68bb83cf&"
import script from "./ExpensesStastiticNavBar.vue?vue&type=script&lang=ts&"
export * from "./ExpensesStastiticNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./ExpensesStastiticNavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports